var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LoginModal'),_c('ForgetModal'),_c('router-view',{staticClass:"route-appssssssss"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }